export default "__VITE_ASSET__CFjrVjJi__"